import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import type { SymbolPaletteItem } from "./types";

export const SymbolPaletteButton = observer(function SymbolPaletteButton({
  item,
  id,
  panelId,
}: {
  item: SymbolPaletteItem;
  id: string;
  /** The tab panel this tab shows while selected */
  panelId: string;
}) {
  const t = useTranslations();
  const { view } = useStore();
  const isActive = item.key === view.symbolPaletteActiveKey;

  const handleClick = () => {
    view.toggleActivePaletteSymbolKey(item.key);
  };

  return (
    <button
      type="button"
      role="tab"
      id={id}
      aria-selected={isActive}
      aria-controls={isActive ? panelId : undefined}
      onClick={handleClick}
      className={twMerge(
        "flex items-center rounded-6 h-7 pl-2 pr-2.5 bg-document-bg",
        "font-mono uppercase text-size-12 text-document-text",
        "[&:last-child]:-tracking-[2px] [&:last-child]:px-1.5",
        isActive && " bg-blue-100 dark:bg-blue-900 ",
      )}
    >
      {item.symbol && (
        <span
          className={twMerge(
            "text-blue-600 dark:text-blue-500",
            isActive && "text-blue-700 dark:text-blue-300",
          )}
        >
          {item.symbol}&nbsp;
        </span>
      )}
      {item.shortNameIntlKey ? t(item.shortNameIntlKey) : t(item.nameIntlKey)}
    </button>
  );
});
